import { gql } from "@apollo/client";

export const EXPRESS_NOTIFICATIONS = gql`
subscription Subscription($userId: String!) {
  expressNotification(userId: $userId) {
    notifications{
      petName
      imageUrl
      userId
    }
  }
}
`;
